// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetSafetyHookByIdRequestModel from '../../model/get-safety-hook-by-id-request-model';
import GetSafetyHookByIdRequestDTO from '../dto/get-safety-hook-by-id-request-dto';
import dtoSchema from '../schemas/get-safety-hook-by-id-request-schema';

export default abstract class GetSafetyHookByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetSafetyHookByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetSafetyHookByIdRequestDTO>): GetSafetyHookByIdRequestModel;
  static toModel(dto: DeepPartial<GetSafetyHookByIdRequestDTO> | undefined | null): GetSafetyHookByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetSafetyHookByIdRequestDTO> | undefined | null): GetSafetyHookByIdRequestModel | undefined {
    return dto ? new GetSafetyHookByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetSafetyHookByIdRequestModel> | GetSafetyHookByIdRequestModel): GetSafetyHookByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetSafetyHookByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetSafetyHookByIdRequestModel, can not map to GetSafetyHookByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
